import { Chip, Tooltip } from "@heroui/react";

export type Colors =
	| "default"
	| "success"
	| "primary"
	| "secondary"
	| "warning"
	| "danger"
	| undefined;
export default function ChipList({
	chips,
	listSize = 2,
}: {
	chips: {
		label: string;
		color: Colors;
		variant?:
			| "flat"
			| "shadow"
			| "solid"
			| "bordered"
			| "light"
			| "faded"
			| "dot"
			| undefined;
	}[];
	listSize?: number;
}) {
	if (!chips) return null;

	const rest = chips.slice(listSize);

	return (
		<div className="flex flex-row gap-1 justify-start min-w-[100px]">
			{chips.slice(0, listSize).map((chip, i) => (
				<Chip
					key={`${JSON.stringify(chip)}-${i}`}
					color={chip.color}
					variant={chip.variant || "flat"}
					size="sm"
					radius="sm"
					className="text-xs"
				>
					{chip.label}
				</Chip>
			))}

			{rest?.length > 0 && (
				<Tooltip
					content={
						<div className="flex flex-col gap-1 py-2">
							{rest.map((elem, i) => (
								<Chip
									size="sm"
									radius="sm"
									variant="flat"
									className="text-xs"
									key={`${JSON.stringify(elem)}-${i}`}
									color={elem.color}
								>
									{elem.label}
								</Chip>
							))}
						</div>
					}
				>
					<Chip
						color="default"
						variant="flat"
						size="sm"
						radius="sm"
						className="text-xs"
					>
						+ {rest.length}
					</Chip>
				</Tooltip>
			)}
		</div>
	);
}
